module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page bg-gray"
  }, [_c('backTitleBar'), _vm._v(" "), _c('div', {
    staticClass: "pd-025"
  }, [_c('div', {
    staticClass: "flex-center bg-fff pd-25 row-item mt-20 click",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'shopBaseInfo'
        })
      }
    }
  }, [_c('div', {
    staticClass: "alifont icon-jibenxinxi color-main"
  }), _vm._v(" "), _c('div', {
    staticClass: "fs-32 color-333 text"
  }, [_vm._v("基本信息")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-center bg-fff pd-25 row-item mt-20 click",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'shopQualifyInfo'
        })
      }
    }
  }, [_c('div', {
    staticClass: "alifont icon-zizhixinxi",
    staticStyle: {
      "color": "#FFB419"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fs-32 color-333 text"
  }, [_vm._v("资质信息")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-center bg-fff pd-25 row-item mt-20 click",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'shopBankInfo'
        })
      }
    }
  }, [_c('div', {
    staticClass: "alifont icon-yinhangkaxinxi",
    staticStyle: {
      "color": "#4483FF"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fs-32 color-333 text"
  }, [_vm._v("银行卡信息")])]), _vm._v(" "), _c('div', {
    staticClass: "flex-center bg-fff pd-25 row-item mt-20 click",
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'shopMainInfo'
        })
      }
    }
  }, [_c('div', {
    staticClass: "alifont icon-dianpupeizhi",
    staticStyle: {
      "color": "#FF8151"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "fs-32 color-333 text"
  }, [_vm._v("店铺配置")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-53b8953d","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/shop/shopSetting/index.vue
// module id = ZDoF
// module chunks = 51